module.exports = __webpack_public_path__ + "media/images/btn_icon_header_beginner-a51c3c75a8edf67f2ca1c987c4941b54.png";